export {
    segmentSearchEvent,
    segmentSearchResultClickEvent,
    segmentSearchResultImpressionEvent
} from './lib/segment';
